import NextLink from 'next/link';

import {
  LinkWithButtonStyles,
  Modal,
} from '@frontendmentorio/design-system-v2';

export default function ErrorModal({ modal }) {
  return (
    <Modal modal={modal}>
      <Modal.Heading>
        We're still waiting for payment confirmation
      </Modal.Heading>

      <p>
        Payment has been received, but there’s a delay receiving confirmation
        from our payment provider. Normally this is resolved with in a few
        minutes, but in extreme cases it can take a few hours.
      </p>

      <p>
        Sorry that this is taking a little while longer than usual. There’s many
        factors that could have caused this, like heavy traffic on our site, or
        at the payment gateway, or a network issue somewhere in between.
      </p>

      <p>
        Our support team have been notified that you’re still waiting so that
        they can investigate. In the mean time if you have any questions or
        concerns you can contact us at{' '}
        <NextLink
          className="underline hover:no-underline"
          href="mailto:hi@frontendmentor.io"
        >
          hi@frontendmentor.io
        </NextLink>
        .
      </p>

      <p>For now, why not try a free challenge?</p>

      <LinkWithButtonStyles
        className="self-center"
        href="/challenges"
        isWide
        onClick={modal.close}
      >
        Browse challenges
      </LinkWithButtonStyles>
    </Modal>
  );
}
